import { render } from "./BuyerInputGroup.vue?vue&type=template&id=5920cd27"
import script from "./BuyerInputGroup.vue?vue&type=script&lang=js"
export * from "./BuyerInputGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__